// extracted by mini-css-extract-plugin
export default {"loadMore":"X5xD6X"};